import { LabelLangString } from "component/LabelLang/label-lang";
import "./Dropdown.scss";
import { useSelector } from "react-redux";
import { TextSlicer } from "functions/textSlicer";


const Dropdown = ({item = [] , name = '' , placeholder = null, change = null, required = false,icon=true}) => {

    const dir = useSelector(({theme})=>theme.direction);
    const currentLocale = useSelector(({ theme }) => theme.locale);

    return (
        <div className="form">
            <div className="dropdown">
                <select className={`${dir == 'rtl' ? 'r-dir' : 'l-dir'}`} name={name} id={name} onChange={change} required={required}>
                    {placeholder ?
                        <option value={0}>{placeholder}</option>
                        :
                        ''
                    }
                    {item && item.map(({id , name , translations} , i) => (
                        <option 
                            key={i}
                            value={id}
                            title={LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: translations,
                            })}
                        >
                            <TextSlicer
                                txt={LabelLangString({
                                    id: "name",
                                    currentLocale: currentLocale,
                                    defaultValue: name,
                                    translations: translations,
                                })}
                                max={50}
                            />
                        </option>
                    ))}
                </select>
                {icon&&<div className="dropdown-icon" />}
            </div>
        </div>

    );
}
export default Dropdown;